import React, { FormEvent } from 'react';
import { RegistrationContainer } from '@bumble/app/components/RegistrationContainer';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import KeyIcon from '@mui/icons-material/Key';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {
  Alert,
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

export const SetPassword = () => {
  const api = useApi();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('iam_user_token');
  const [password, setPassword] = React.useState('');
  const [confirm, setConfirm] = React.useState('');
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirm, setShowConfirm] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowConfirm = () => setShowConfirm((show) => !show);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  const handleMouseDownConfirm = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  const validateSame = () => {
    if (password === '' || confirm === '') return true;
    return password !== confirm;
  };

  const setIamPassword = useMutation(api.newIamUserSetupPasswordApiV1NewIamUserSetPasswordPost, {
    onSuccess() {
      toast.success('Password set, please log in with your new password.');
      navigate('/login');
    },
    onError: apiError,
  });

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (token) {
      setIamPassword.mutate({
        password,
        iam_user_token: token,
      });
    }
  };

  if (!token) {
    return (
      <RegistrationContainer>
        <Alert severity="error" sx={{ my: 5 }}>
          Invalid password link.
        </Alert>
      </RegistrationContainer>
    );
  }

  return (
    <RegistrationContainer>
      <Typography variant="body1" component="p" py={2} mb={2}>
        Please choose your new password.
      </Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          margin="normal"
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
            startAdornment: (
              <InputAdornment position="start">
                <KeyIcon />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          fullWidth
          label="Confirm Password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          margin="normal"
          type={showConfirm ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowConfirm}
                  onMouseDown={handleMouseDownConfirm}
                  edge="end"
                >
                  {showConfirm ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
            startAdornment: (
              <InputAdornment position="start">
                <KeyIcon />
              </InputAdornment>
            ),
          }}
        />
        <Box mt={4}>
          <Button
            variant="contained"
            size="large"
            fullWidth
            disabled={validateSame()}
            type="submit"
          >
            Set Password
          </Button>
        </Box>
      </Box>
    </RegistrationContainer>
  );
};
